import { useContext } from "react";
import { OnlineVisit } from "src/api/types";
import { VisitContext } from "./VisitProvider";

export function useVisit<T>(selector: (visit: OnlineVisit) => T) {
  const visit = useContext(VisitContext);

  if (visit == null) {
    throw new Error("useVisit was used outside of VisitProvider");
  }

  return selector(visit);
}
